import React from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { Button } from 'antd'

const UploadWrapper = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  margin-top: 16px;
  margin-bottom: 12px;
`
const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const UploadDesc = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
`

export const ErrorFile = ({
  network,
  resetError,
}: {
  network: string
  resetError: (b: boolean) => void
}) => {
  return (
    <ErrorWrapper>
      <ExclamationCircleOutlined style={{ fontSize: '70px', color: '#FF0900' }} />
      <UploadWrapper>Wrong file uploaded</UploadWrapper>
      <UploadDesc>
        Uploaded file is invalid or isn’t for the right network. Please upload file
        generated for this network ({network})
      </UploadDesc>
      <Button onClick={() => resetError(false)}>Upload a new file</Button>
    </ErrorWrapper>
  )
}
